// extracted by mini-css-extract-plugin
export default {"pageWrap":"Jc-z","fullWidth":"Kc-z","heading":"Lc-z","fullBleed":"Mc-z","hidden":"Nc-z"};